import React from 'react'
import PropTypes from 'prop-types'
import './Bar.less'

export default function Bar({ dataset }) {
	return (
		<div className="chart bar">
			{dataset.map((set, i) => (
				<div className="set" key={i}>
					<div className="label">{set.label}</div>
					<div className="bar">
						<div
							className={`value value-${set.percent}`}
							style={{
								width: `${set.percent}%`,
							}}
						/>
					</div>
				</div>
			))}
		</div>
	)
}

Bar.propTypes = {
	dataset: PropTypes.arrayOf(PropTypes.shape({
		label: PropTypes.string,
		percent: PropTypes.number,
	})),
}

Bar.defaultProps = {
	dataset: [],
}



// WEBPACK FOOTER //
// ./src/components/common/charts/Bar.jsx